import FormItem from "@components/formItem";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, Stake } from "../baseItems";
import Base from "./base";

class Ixirpay extends Base {
	onSelectPaymentMethodLocal(e) {
		this.setState(
			{
				paymentMethod: e.label,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectBankLocal(e) {
		this.setState(
			{
				selectedBank: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { banks } = this.props,
			{ paymentMethod, selectedBank } = this.state;
		const options = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: 1, label: "qr" },
			{ value: 2, label: "cepbank" },
		];
		let selectedMethod = paymentMethod
			? options.find((o) => o.label === paymentMethod).value
			: 0;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];
		banks.map((item, index) => {
			let newOpt = { value: index, label: item.name };
			bankOptions.push(newOpt);
		});
		let bank = selectedBank ? bankOptions.find((o) => o.value === selectedBank).value : 0;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				<FormItem onRegister={() => this.registerField({ name: "paymentMethod" })}>
					<Box>
						<BoxTitle>{translate("SELECT_PAYMENT_METHOD")}</BoxTitle>
						<PaymentSelect
							options={options}
							value={selectedMethod}
							onLoad={() => this.registerField({ name: "paymentMethod" })}
							handleSelect={this.onSelectPaymentMethodLocal.bind(this)}
						/>
					</Box>
				</FormItem>
				{paymentMethod && paymentMethod !== "" && (
					<Fragment>
						<FormItem onRegister={() => this.registerField({ name: "selectedBank" })}>
							<Box>
								<BoxTitle>{translate("SELECT_BANK")}</BoxTitle>
								<PaymentSelect
									options={bankOptions}
									value={bank}
									onLoad={() => this.registerField({ name: "selectedBank" })}
									handleSelect={this.onSelectBankLocal.bind(this)}
								/>
							</Box>
						</FormItem>
						{this.getStakeField()}
						{this.renderMinMax()}
					</Fragment>
				)}
			</Content>
		);
	}

	renderMinMax() {
		const { selectedBank, selectedCurrency } = this.state;
		const { banks, selectedDeposit } = this.props;

		const currencyToUse = selectedCurrency || selectedDeposit?.currencies?.[0]?.currency;
		let selected = banks.find((item) => item.name == selectedBank);
		return (
			<Translate>
				{({ translate }) => (
					<div>
						{selectedBank && selectedBank !== "" && (
							<Box>
								<BoxTitle>
									{translate("MIN")} - {translate("MAX")}
								</BoxTitle>
								<Stake>
									{`${formatMoney(
										selected.limit.min,
										currencyToUse
									)} - ${formatMoney(selected.limit.max, currencyToUse)}`}
								</Stake>
							</Box>
						)}
					</div>
				)}
			</Translate>
		);
	}

	makeExternalPayment(newStep) {
		const { stake, selectedBank, selectedCurrency } = this.state;
		const { banks } = this.props;
		let bank = banks.find((item) => item.name == selectedBank);
		this.props.externalFunc.depositIxirpay(
			{
				amount: stake,
				value: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
				sessionId: getUser().sessionId,
				bankCode: bank.code,
				language: this.getActiveLanguageCode(),
				isRedirect: 0,
				redirectionUrl: "",
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, selectedBank, selectedCurrency } = this.state;
		const { banks } = this.props;
		let bank = banks.find((item) => item.name == selectedBank);
		this.props.externalFunc.depositIxirpay(
			{
				amount: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
				sessionId: getUser().sessionId,
				bankCode: bank.code,
				language: this.getActiveLanguageCode(),
				isRedirect: 0,
				redirectionUrl: "",
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}

const mapStateToProps = (state) => ({
	banks: state.deposit.bankList,
});

export default connect(mapStateToProps, null)(Ixirpay);
